<h1>
  {{ companyName }}
</h1>
<div fxLayout="row" fxLayoutAlign="center center">
  <div fxFlex="65" fxFlex.lt-md="100" class="profile-card">
    <app-company-invitation-detail></app-company-invitation-detail>
  </div>
</div>
